import { prefetchInfiniteSearch, prefetchPage, prefetchTranslation } from '@Navigation/prefetchers';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (query) => async (args) => {
  const { queryClient } = query;
  const { request } = args;

  return Promise.all([
    prefetchTranslation(request.url, queryClient),
    prefetchPage(request.url, queryClient),
    prefetchInfiniteSearch(request.url, queryClient),
  ]);
};
